module.exports = __webpack_public_path__ + "static/media/01.5cd97dca.jpg";